import { accountMessagesStyles } from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import getColor from "@insite/mobius/utilities/getColor";
import { blackBlueBtn } from "@tKgpco/Extensions/Components/WishListCardExtension";
import { COLORS } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(accountMessagesStyles, {
    messagesAccordion: {
        css: css`
            width: 100%;
            > dt > button {
                background-color: ${COLORS.background.shade};
            }
        `,
    },
    messageFilter: {
        radioGroup: {
            css: css`
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            `,
        },
        radioButton: {
            css: css`
                margin-top: 10px;
                margin-right: 15px;
            `,
        },
    },
    messageCard: {
        gridContainer: { gap: 5 },
        article: {
            css: css`
                width: 100%;
            `,
        },
        dateTimeGridItem: { width: 12 },
        dateTimeText: { weight: "bold" },
        subjectGridItem: { width: 12 },
        bodyGridItem: { width: 12 },
        actionButtonGridItem: {
            width: 12,
            css: css`
                justify-content: flex-end;
            `,
        },
        bottomBorderGridItem: { width: 12 },
        bottomBorder: {
            css: css`
                height: 1px;
                width: 100%;
                background: ${getColor("common.accent")};
            `,
        },
        actionButton: blackBlueBtn.actionDeleteButton,
    },
});
